import { ENVIRONMENT } from "./environment";

export default function devLog(...args: unknown[]) {
  if (ENVIRONMENT.APP_ENV === "local") {
    console.log(...args);
  }
}
